import appIcon from "../../../assets/images/Smartphone.svg";
import businessIcon from "../../../assets/images/Money.svg";
import LeaderTeam from "../../../assets/images/Leader_Team.png";
import paymentIcon from "../../../assets/images/verifyTrades/paymentSidebarIcon.svg";
import tradingIcon from "../../../assets/images/verifyTrades/tradingIcon.svg";
import verifiedTradeLightIcon from "../../../assets/images/verifyTrades/verifiedTradeLightIcon.svg";
import verifiedTradeDarkIcon from "../../../assets/images/verifyTrades/verifiedTradeDarkIcon.svg";
import settingsIcon from "../../../assets/images/verifyTrades/settingsIcon.svg";
import newDashboardIcon from "../../../assets/images/newDashboardIcon.svg";
import copyTradingIcon from "../../../assets/images/copyTradingIcon.svg";

const allLeaderSideBarControls = [
  {
    key: "dashboard",
    label: "Dashboard",
    currentPageTitle: "Dashboard",
    url: "/leader/dashboard",
    isDropDown: false,
    icon: (
      <img
        alt="newDashboardIcon"
        src={newDashboardIcon}
        style={{ height: "25px" }}
      />
    ),
  },
  {
    key: "copyTrade",
    label: "Copy trade",
    currentPageTitle: "Copy Trade Service",
    url: "/leader/newCopyTrade",
    isDropDown: false,
    icon: (
      <img alt="copyTradingIcon" src={copyTradingIcon} style={{ height: 22 }} />
    ),
  },
  {
    key: "verifiedTrading",
    label: "Verified Trading",
    currentPageTitle: "Verified Trading",
    url: "/leader/verifiedTrading",
    isDropDown: false,
    icon: (
      <img
        alt="verifiedTradeDarkIcon"
        src={verifiedTradeDarkIcon}
        style={{ height: "25px" }}
      />
    ),
  },
  {
    key: "trading",
    label: "Trading",
    currentPageTitle: "Trading",
    url: "/leader/verifyTradeListing",
    isDropDown: false,
    icon: (
      <img alt="tradingIcon" src={tradingIcon} style={{ height: "25px" }} />
    ),
  },
  {
    key: "members",
    label: "Members",
    currentPageTitle: "Members",
    url: "/leader/memberListening",
    isDropDown: false,
    icon: <img src={LeaderTeam} alt="LeaderTeam" style={{ height: "25px" }} />,
  },
  {
    key: "business",
    label: "Business",
    currentPageTitle: "Business",
    url: "/leader/payment",
    isDropDown: false,
    icon: (
      <img alt="businessIcon" src={businessIcon} style={{ height: "25px" }} />
    ),
  },
  {
    key: "payment",
    label: "Payment",
    currentPageTitle: "Payment",
    url: "/leader/verifiedPaymentBillingHistory",
    isDropDown: false,
    icon: (
      <img alt="paymentIcon" src={paymentIcon} style={{ height: "25px" }} />
    ),
  },
  {
    key: "settings",
    label: "Settings",
    currentPageTitle: "Settings",
    url: "/leader/newAccountSettings",
    isDropDown: false,
    icon: (
      <img alt="settingsIcon" src={settingsIcon} style={{ height: "25px" }} />
    ),
  },
];

// Role to keys mapping
const leaderSideBarRoleKeys = {
  traderOnly: [
    "dashboard",
    "verifiedTrading",
    "trading",
    "payment",
    "settings",
  ],
  communityOnly: [
    "dashboard",
    "copyTrade",
    // "verifiedTrading",
    "trading",
    "members",
    "business",
    // "payment",
    "settings",
  ],
  traderAndCommunity: [
    "dashboard",
    "copyTrade",
    "verifiedTrading",
    "trading",
    "members",
    "business",
    "payment",
    "settings",
  ],
};

// Helper to get sidebar items by rights of leaders
export function getLeaderSideBarItems(role) {
  const keys = leaderSideBarRoleKeys[role] || [];
  return allLeaderSideBarControls.filter((item) => keys.includes(item.key));
}

export const traderSideBarItems = [
  {
    label: "Dashboard",
    currentPageTitle: "Dashboard",
    url: "/leader/dashboard",
    isDropDown: false,
    icon: (
      <img
        alt="newDashboardIcon"
        src={newDashboardIcon}
        style={{ height: "25px" }}
      />
    ),
  },
  // {
  //   label: "Verify Trade Dashboard",
  //   currentPageTitle: "Verify Trade Dashboard",
  //   url: "/leader/verifyMyTradeDashboard",
  //   isDropDown: false,
  //   icon: <img alt="newDashboardIcon" src={newDashboardIcon} style={{ height: "25px" }} />,
  // },
  // {
  //   label: "Copy Trade",
  //   currentPageTitle: "Copy Trade Service",
  //   url: "/leader/newCopyTrade",
  //   isDropDown: false,
  //   icon: (
  //     <svg
  //       height="18.966"
  //       viewBox="0 0 18.966 18.966"
  //       width="18.966"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <g transform="translate(-6.25 -6.25)">
  //         <path
  //           d="M13.7,20.474H8.282A2.031,2.031,0,0,1,6.25,18.443V8.282A2.032,2.032,0,0,1,8.282,6.25h14.9a2.032,2.032,0,0,1,2.032,2.032V18.443a2.031,2.031,0,0,1-2.032,2.031H17.765v3.387H19.8a.677.677,0,1,1,0,1.355H11.669a.677.677,0,0,1,0-1.355H13.7Zm2.709,3.387V20.474H15.056v3.387ZM8.282,19.12h14.9a.677.677,0,0,0,.677-.677V8.282a.677.677,0,0,0-.677-.677H8.282a.677.677,0,0,0-.677.677V18.443A.677.677,0,0,0,8.282,19.12Zm12.771-7.19-1.98,3.462a.676.676,0,0,1-1.061.148l-1.542-1.508-2.241,2.8a.678.678,0,0,1-1.008.056l-1.473-1.474-1.521,2.073a.677.677,0,1,1-1.092-.8l1.988-2.709a.672.672,0,0,1,.494-.274.679.679,0,0,1,.531.2l1.5,1.5,2.236-2.8a.678.678,0,0,1,1-.062l1.45,1.419,1.6-2.806-.489.148a.678.678,0,1,1-.392-1.3L21,9.415a.677.677,0,0,1,.844.453l.588,1.945a.678.678,0,0,1-1.3.392Z"
  //           fill-rule="evenodd"
  //           transform="translate(0 0)"
  //         />
  //       </g>
  //     </svg>
  //   ),
  // },
  {
    label: "Verified Trading",
    currentPageTitle: "Verified Trading",
    url: "/leader/verifiedTrading",
    isDropDown: false,
    icon: (
      <img
        alt="verifiedTradeDarkIcon"
        src={verifiedTradeDarkIcon}
        style={{ height: "25px" }}
      />
    ),
  },
  {
    label: "Trading",
    currentPageTitle: "Trading",
    url: "/leader/tradingListening",
    isDropDown: false,
    icon: (
      <svg
        height="15.386"
        viewBox="-1 0.021 24 15.386"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.922.655a1.03 1.03 0 0 0-.219-.334c-.006-.006-.012-.007-.017-.012a1.027 1.027 0 0 0-.311-.21.993.993 0 0 0-.298-.061c-.03-.002-.055-.017-.085-.017h-8.068c-.557 0-1.008.46-1.008 1.027s.45 1.026 1.008 1.026h5.643l-7.982 8.171-3.037-3.958a1.002 1.002 0 0 0-.72-.392.988.988 0 0 0-.769.278l-7.744 7.463a1.04 1.04 0 0 0-.04 1.452 1.002 1.002 0 0 0 1.427.039L7.64 8.44l3.059 3.985a1.001 1.001 0 0 0 1.51.093l8.774-8.982v5.723c0 .567.45 1.026 1.009 1.026.557 0 1.008-.459 1.008-1.026V1.047a1.07 1.07 0 0 0-.078-.392Z"
          data-name="Shape"
          fill-rule="evenodd"
        />
      </svg>
    ),
  },
  {
    label: "Verify Trading",
    currentPageTitle: "Verified Trading",
    url: "/leader/verifyTradeListing",
    isDropDown: false,
    icon: (
      <img alt="tradingIcon" src={tradingIcon} style={{ height: "25px" }} />
    ),
  },
  // {
  //   label: "Trading",
  //   url: "#",
  //   isDropDown: true,
  //   icon: (
  //     <svg
  //       height="15.386"
  //       viewBox="-1 0.021 24 15.386"
  //       width="24"
  //       xmlns="http://www.w3.org/2000/svg"
  //     >
  //       <path
  //         d="M22.922.655a1.03 1.03 0 0 0-.219-.334c-.006-.006-.012-.007-.017-.012a1.027 1.027 0 0 0-.311-.21.993.993 0 0 0-.298-.061c-.03-.002-.055-.017-.085-.017h-8.068c-.557 0-1.008.46-1.008 1.027s.45 1.026 1.008 1.026h5.643l-7.982 8.171-3.037-3.958a1.002 1.002 0 0 0-.72-.392.988.988 0 0 0-.769.278l-7.744 7.463a1.04 1.04 0 0 0-.04 1.452 1.002 1.002 0 0 0 1.427.039L7.64 8.44l3.059 3.985a1.001 1.001 0 0 0 1.51.093l8.774-8.982v5.723c0 .567.45 1.026 1.009 1.026.557 0 1.008-.459 1.008-1.026V1.047a1.07 1.07 0 0 0-.078-.392Z"
  //         data-name="Shape"
  //         fill-rule="evenodd"
  //       />
  //     </svg>
  //   ),
  //   subItems: [
  //     { label: "Overview", url: "/leader/overview", currentPageTitle: "" },
  //     {
  //       label: "Open Trades",
  //       url: "/leader/liveTrade",
  //       currentPageTitle: "",
  //     },
  //     {
  //       label: "Closed Trades",
  //       url: "/leader/closedTrade",
  //       currentPageTitle: "",
  //     },
  //   ],
  // },
  // {
  //   label: "Members",
  //   currentPageTitle: "Members",
  //   url: "/leader/memberListening",
  //   isDropDown: false,
  //   icon: <img src={LeaderTeam} alt="LeaderTeam" style={{ height: "25px" }} />,
  // },
  // {
  //   label: "Business",
  //   url: "#",
  //   isDropDown: true,
  //   icon: <img alt="" src={businessIcon} style={{ height: "25px" }} />,
  //   subItems: [
  //     {
  //       label: "Performance",
  //       url: "/leader/performance",
  //       currentPageTitle: "",
  //     },
  //     { label: "Reports", url: "/leader/reports", currentPageTitle: "" },
  //     { label: "Payment", url: "/leader/payment", currentPageTitle: "" },
  //     {
  //       label: "Payout history",
  //       url: "/leader/payoutHistory",
  //       currentPageTitle: "",
  //     },
  //   ],
  // },
  // {
  //   label: "Business",
  //   currentPageTitle: "Business",
  //   url: "/leader/payment",
  //   isDropDown: false,
  //   icon: <img alt="businessIcon" src={businessIcon} style={{ height: "25px" }} />,
  // },
  {
    label: "Payment",
    currentPageTitle: "Payment",
    url: "/leader/verifiedPaymentBillingHistory",
    isDropDown: false,
    icon: (
      <img alt="paymentIcon" src={paymentIcon} style={{ height: "25px" }} />
    ),
  },
  {
    label: "Settings",
    currentPageTitle: "Settings",
    url: "/leader/newAccountSettings",
    isDropDown: false,
    icon: (
      <img alt="settingsIcon" src={settingsIcon} style={{ height: "25px" }} />
    ),
  },
  // {
  //   label: "App",
  //   url: "#",
  //   isDropDown: true,
  //   icon: <img alt="" src={appIcon} />,
  //   subItems: [
  //     { label: "About the App", url: "/leader/app", currentPageTitle: "" },
  //     { label: "Pricing", url: "/leader/appPricing", currentPageTitle: "" },
  //     { label: "Promote App", url: "/leader/promoteApp", currentPageTitle: "" },
  //   ],
  // },
];
